module.exports = __webpack_public_path__ + "static/media/01-1.90af8630.webp";